module.exports={"(optional)":"(optional)","(required)":"(erforderlich)"};